export const commercialsFaqArray = [
  {
    question: 'What kind of commercials do you create?',
    answer:
      'I produce a range of content including short ads, UGC-style videos, branded storytelling, and testimonials. Each project is tailored to your brand’s needs and goals.',
  },
  {
    question: 'Do you only work with local clients?',
    answer:
      'No — while I am based in Drammen, Norway, I collaborate with clients worldwide through online communication and digital delivery of projects.',
  },
  {
    question: 'Can you edit videos I already have?',
    answer:
      'Yes. If you provide raw footage, I can handle editing, sound design, and visual polish to transform your clips into professional content.',
  },
  {
    question: 'What does the process look like?',
    answer:
      'We start with a consultation to understand your goals. From there, I create concepts, produce or edit content, and include review rounds so you can give feedback along the way.',
  },
  {
    question: 'How long does it take to deliver a commercial?',
    answer:
      'Turnaround time depends on the scope of the project. Simple edits may take a few days, while full productions may take 2–4 weeks.',
  },
  {
    question: 'Do you offer package pricing?',
    answer:
      'Each project is custom. Pricing depends on complexity, length, and deliverables. Contact me for a quote tailored to your needs.',
  },
];